export default __webpack_public_path__ + "static/media/postgresql-original.62bba1b3.svg";